import { services } from "./ServicesData";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styles from "../Services.module.css";
import { useTranslation } from "react-i18next";
import SVGTitle from "./SVGTitle";

const Services = () => {
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div className="container py-5 my-5" id="services" dir={dir}>
      <Helmet>
        <html lang={i18n.language} dir={dir} />
        <title>{t("services.seo.title")}</title>
        <meta name="description" content={t("services.seo.description")} />
        <meta name="keywords" content={t("services.seo.keywords")} />

        <meta property="og:title" content={t("services.seo.ogTitle")} />
        <meta
          property="og:description"
          content={t("services.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://slimsmile.ps/images/services.jpg"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:locale"
          content={i18n.language === "ar" ? "ar_AR" : "en_US"}
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            serviceType: t("services.schema.type"),
            provider: {
              "@type": "MedicalBusiness",
              name: "مركز سليم سمايل",
              address: {
                "@type": "PostalAddress",
                addressLocality: "رام الله",
                addressCountry: "PS",
              },
            },
            hasOfferCatalog: {
              "@type": "OfferCatalog",
              name: t("services.schema.catalog"),
              itemListElement: services.map((service) => ({
                "@type": "Offer",
                itemOffered: {
                  "@type": "Service",
                  name: service.title,
                  url: `/articles/${service.slug}`,
                  image: service.image,
                },
              })),
            },
          })}
        </script>
      </Helmet>

      <div className="head text-center">
        <h2 className="mb-4 fs-1 fw-bolder">{t("services.title")}</h2>
        <SVGTitle />
      </div>

      <div className="row">
        {services.map((service) => (
          <div
            className="col-6 col-lg-3 col-md-4 col-sm-6 my-4"
            key={service.id}
          >
            <motion.div
              className={styles.container}
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: false, amount: 0.3 }}
              transition={{ duration: 0.3, ease: "linear" }}
            >
              <div className={styles.card}>
                <div className={styles.front}>
                  <img
                    src={service.image}
                    loading="lazy"
                    alt={t(`servicesList.${service.slug}`)}
                    className={styles.frontHeading}
                  />
                  <h6 className="text-dark text-center">
                    {t(`servicesList.${service.slug}`)}
                  </h6>
                </div>
                <div className={styles.back}>
                  <img
                    src={service.image}
                    loading="lazy"
                    alt={t(`servicesList.${service.slug}`)}
                    className={styles.backHeading}
                  />
                  <Link
                    to={`/articles/${service.slug}`}
                    className="btn btn-outline-dark"
                  >
                    {t("services.readMore")}
                  </Link>
                </div>
              </div>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
